<p-dialog
  data-testid="selection-dialog"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="dialogStyle()"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [header]="config?.title | translate"
>
  <div class="flex flex-col h-full">
    <!-- Search and Filter Section -->
    <div class="flex-shrink-0 px-4 py-2">
      <div
        class="grid grid-cols-1 md:grid-cols-{{
          config?.searchFields?.length || 1
        }} gap-4"
      >
        <div *ngFor="let field of config?.searchFields || []" class="space-y-2">
          <label class="block text-sm font-medium text-gray-700">
            {{ field.label | translate }}
          </label>
          <input
            [attr.data-testid]="'selection-dialog-search-input-' + field.key"
            pInputText
            [(ngModel)]="searchForm()[field.key]"
            [placeholder]="field.placeholder | translate"
            class="w-full"
          />
        </div>
      </div>
      <div class="flex gap-2 mt-3 mb-1">
        <app-button
          [testId]="'selection-dialog-search-btn'"
          [label]="'common.actions.search' | translate"
          [type]="'info'"
          (emitOnClick)="onSearch()"
        ></app-button>
        <app-button
          [testId]="'selection-dialog-reset-btn'"
          [label]="'common.actions.reset' | translate"
          [type]="'secondary'"
          [outlined]="true"
          (emitOnClick)="onSearchReset()"
        ></app-button>
      </div>
    </div>

    <!-- Items Table -->
    <app-data-table
      data-testid="selection-dialog-table"
      [dataSource]="items"
      [columns]="config?.tableColumns || []"
      [loading]="loading"
      [hasCheckColumn]="true"
      [hasSerialColumn]="false"
      [hasHeaderCheckbox]="config?.type === 'product'"
      [isRowDisabledFn]="
        config?.type === 'product' ? isItemDisabled.bind(this) : undefined
      "
      [isRowSelectedFn]="isItemSelected.bind(this)"
      [rows]="pageSize()"
      [first]="(currentPage() - 1) * pageSize()"
      [totalRecords]="totalRecords"
      [selection]="selectedItems()"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
      scrollHeight="500px"
    >
    </app-data-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <app-button
        [testId]="'selection-dialog-cancel-btn'"
        [label]="'common.actions.cancel' | translate"
        [type]="'secondary'"
        [outlined]="true"
        (emitOnClick)="onCancel()"
        [disabled]="loading"
      ></app-button>
      <app-button
        [testId]="'selection-dialog-confirm-btn'"
        [label]="
          config?.confirmButtonLabel || ('common.actions.confirm' | translate)
        "
        [type]="'info'"
        (emitOnClick)="onConfirm()"
        [disabled]="selectedItems().length === 0 || loading"
        [loading]="loading"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>
